import { Button, Confirm, Delete } from '@core/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteSlideButtonProps } from './types';

export const DeleteSlideButton = ({ onClick, onDeleteSlideClick, ...props }: DeleteSlideButtonProps) => {
    const [deleteSlideConfirmationShown, setDeleteSlideConfirmationShown] = useState(false);

    const showDeleteSlideConfirmation = () => {
        setDeleteSlideConfirmationShown(true);
    };

    const { t } = useTranslation();

    return (
        <>
            <Button iconbtn onClick={showDeleteSlideConfirmation} {...props}>
                <Delete classNames="size-6 stroke-warning" />
            </Button>
            <Confirm
                title={t('Content.Slides.ConfirmDelete.Title')}
                open={deleteSlideConfirmationShown}
                onClose={() => setDeleteSlideConfirmationShown(false)}
                onConfirm={() => {
                    onDeleteSlideClick();
                }}
                key="deleteSlidePopup"
            >
                {t('Content.Slides.ConfirmDelete.Msg')}
            </Confirm>
        </>
    );
};
